import { render, staticRenderFns } from "./detailAbsenteeism.vue?vue&type=template&id=86ba965a"
import script from "./detailAbsenteeism.vue?vue&type=script&lang=js"
export * from "./detailAbsenteeism.vue?vue&type=script&lang=js"
import style0 from "./detailAbsenteeism.vue?vue&type=style&index=0&id=86ba965a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports